

export interface ContactCompanyRendererProps {
    contactCompany: string | '';
}

const ContactCompanyRenderer = (contact: ContactCompanyRendererProps) => {

    
    return (
      <div>
          <div title={contact.contactCompany}>{contact.contactCompany}</div>
      </div>
    );

  };

  export default ContactCompanyRenderer;
